<template>
    <v-dialog
        v-model="$store.state.groupFSC.rename"
        max-width="1000px"
        transition="dialog-transition"
        persistent
    >
        <v-card>
            <v-toolbar color="primary" dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Rename Groups
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$store.state.groupFSC.rename = false; "><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Group</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(grp,idx) in parms" v-bind:key="'grp'+ idx">
                            <td>
                                {{ grp.InvGroupID }}
                            </td>
                            <td>
                                <v-text-field
                                v-model="grp.GroupName"
                                @change="changeName(grp)"
                                hide-details
                                dense
                                ></v-text-field>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
    export default {
        props:['parms'],
        data: function() {
            return {

            }
        },
        methods:{
            changeName: function(itm) {
                var str = this.$store;
                var parms = {
                    GroupName: itm.GroupName
                }
                axios
                .put('invoice-group-customer/'+ itm.InvGroupID, parms,{
                    headers:{
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(respose => {
                    console.log(respose.data);
                    str.dispatch('setSnackbar', {
                                color: 'success',
                                text:
                                    'Group name updated'
                            });
                        this.$emit('close');
                })
                .catch(err => {
                    console.log(err);
                })
            }
        }
    }
</script>